export default class ApiErrorCode {

    static GENERAL_SYSTEM = 1010;
    static GENERAL_NOT_IMPLEMENTED = 1020;
    static GENERAL_NOT_FOUND = 1030;

    static AUTH_INVALID_ACCOUNT_TYPE = 2010;
    static AUTH_LOGIN_FAILED = 2020;
    static AUTH_TOKEN_INVALID = 2030;
    static AUTH_SESSION_EXPIRED = 2040;
    static AUTH_SESSION_INVALID = 2050;

    static ACCESS_DENIED = 3010;

    static DATA_FAILED = 4010;
    static DATA_NOT_FOUND = 4020;

    static POST_DATA_NOT_PROVIDED = 5010;
    static POST_DATA_INVALID = 5020;

    static USER_EMAIL_EXISTS = 100;
}
